module.exports = __webpack_public_path__ + "img/applemusic.95d360ce.png";